import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import ConfirmationMessage from '../../../components/confirmation-message/index';
import { Tick } from '../../../helpers/icon-dictionary';
import messages from '../messages';
import withModal from '../../with-modal';

const ExtendResultSuccess = (props) => {
    const { intl,
        handleOnClick,
        extendedYearGroups
    } = props;

    const extendedGroups = extendedYearGroups || {};
    const startedFreshFlag = Object.keys(extendedGroups).every(k => !extendedGroups[k]);

    const successTitle = startedFreshFlag ? intl.formatMessage(messages.successTitleStartedFresh) : intl.formatMessage(messages.successTitle);
    const successMessage = startedFreshFlag ? '' : intl.formatMessage(messages.successMessage);
    return (<ConfirmationMessage
        handleOnCloseModal={handleOnClick}
        icon={Tick}
        title={successTitle}>
        {successMessage}
    </ConfirmationMessage>);
};

ExtendResultSuccess.propTypes = {
    handleOnClick: PropTypes.func,
    intl: intlShape.isRequired,
    extendedYearGroups: PropTypes.object
};

export default withModal('isActive')(injectIntl(ExtendResultSuccess));



// WEBPACK FOOTER //
// ./app/components/extend-result/modals/success.js